import { createUseStyles } from 'react-jss'

const useFlexStyles = createUseStyles({
  flexWrapper: {
    display: 'flex',

    '&.column': {
      flexDirection: 'column'
    },
    '&.inline': {
      display: 'inline-flex'
    },
    // Align
    '&.alignCenter': {
      alignItems: 'center'
    },
    '&.alignFlexStart': {
      alignItems: 'flex-start'
    },
    '&.alignFlexEnd': {
      alignItems: 'flex-end'
    },
    // Justify
    '&.justifyStart': {
      justifyContent: 'flex-start'
    },
    '&.justifyCenter': {
      justifyContent: 'center'
    },
    '&.justifyEnd': {
      justifyContent: 'flex-end'
    },
    '&.justifySpaceBetween': {
      justifyContent: 'space-between'
    },
    '&.wrap': {
      flexWrap: 'wrap'
    },
    '&.stretchItems': {
      '& > *': {
        flex: 1
      }
    },
    // Spacing
    '&.spacing-1': {
      gap: '0.625rem'
    },
    '&.spacing-2': {
      gap: '0.75rem'
    },
    '&.spacing-3': {
      gap: '1rem'
    },
    '&.spacing-4': {
      gap: '1.125rem'
    },
    // Margin
    '&.margin-1': {
      margin: '0.625rem'
    },
    '&.margin-2': {
      margin: '0.75rem'
    },
    '&.margin-3': {
      margin: '1rem'
    },
    '&.margin-4': {
      margin: '1.125rem'
    }
  }
})

export { useFlexStyles }
